import { render, staticRenderFns } from "./SubpageCategory.vue?vue&type=template&id=e042d28a&"
import script from "./SubpageCategory.vue?vue&type=script&lang=js&"
export * from "./SubpageCategory.vue?vue&type=script&lang=js&"
import style0 from "./SubpageCategory.vue?vue&type=style&index=0&id=e042d28a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports